export const CATEGORY: string = 'categories';

export const PARAMETERS: string = 'parameters';
export const PARTNERS: string = 'partners';
export const PAYMENT_RECEIPT_FORMS: string = 'PaymentReceiptForms';
export const PRICE_TABLES: string = 'priceTables';
export const PRODUCTS: string = 'products';
export const PROFILE: string = 'profile';

export const RECEIVING_CONDITIONS: string = 'receivingConditions';

export const ORDERS: string = 'orders';
export const DOCUMENT: string = 'document';

export const CONFIGURATION: string = '';

export const ORDERS_CART: string = 'orders/cart';
